import { GAME_DETAIL_MODULE_KEY_MAPPING } from '../constants';

export const scroll2Module = (rootNode?: HTMLElement | null, moduleKey?: string) => {
  if (!rootNode) return;
  switch (moduleKey) {
    // REMARK: Game Information模块暂时不需要滚动
    case GAME_DETAIL_MODULE_KEY_MAPPING.GAME_INFORMATION: {
      break;
    }
    // REMARK: Visual Showcase模块暂时不需要滚动
    case GAME_DETAIL_MODULE_KEY_MAPPING.VISUAL_SHOWCASE: {
      break;
    }
    case GAME_DETAIL_MODULE_KEY_MAPPING.SIMILAR_GAMES: {
      rootNode
        .querySelector('.dbg-project-detail__body-similar')
        ?.scrollIntoView({ block: 'center', behavior: 'smooth' });
      break;
    }
    default: {
    }
  }
};
